import React from 'react';

import { Link } from 'react-router-dom';

import logo from '../assets/images/logo.png';

const Header = () => {

return (

<header

style={{

backgroundColor: '#22225f',

display: 'flex',

justifyContent: 'space-between',

alignItems: 'center',

padding: '20px 50px',

}}

>

<div style={{ display: 'flex', alignItems: 'center' }}>

<img src={logo} alt="CALFIN Logo" style={{ height: '100px', marginRight: '20px' }} />

<h1 style={{ color: '#fff', fontSize: '24px', margin: 0 }}>CALFIN TECHNOLOGIES PRIVATE LIMITED</h1>

</div>

<nav>

<ul style={{ display: 'flex', listStyle: 'none', gap: '20px', margin: 0 }}>

<li>

<Link to="/" style={{ color: '#fff', textDecoration: 'none', fontSize: '16px' }}>Home</Link>

</li>

<li>

<Link to="/about" style={{ color: '#fff', textDecoration: 'none', fontSize: '16px' }}>About</Link>

</li>

<li>

<Link to="/services" style={{ color: '#fff', textDecoration: 'none', fontSize: '16px' }}>Services</Link>

</li>

<li>

<Link to="/tools" style={{ color: '#fff', textDecoration: 'none', fontSize: '16px' }}>Tools</Link>

</li>

<li>

<Link to="/blog" style={{ color: '#fff', textDecoration: 'none', fontSize: '16px' }}>Blog</Link>

</li>

<li>

<Link to="/contact" style={{ color: '#fff', textDecoration: 'none', fontSize: '16px' }}>Contact</Link>

</li>

</ul>

</nav>

</header>

);

};

export default Header;